import axios from "axios";

const auth = JSON.parse(localStorage.getItem("auth") as string);
const LOCAL_URL = "http://localhost:8000";

export const axiosInstance = axios.create({
  baseURL: process.env.API_BASE_URL,
  // baseURL: LOCAL_URL,
  headers: {
    "Content-Type": "application/json",
    Authorization: auth?.token,
  },
});

export const getDataWrapper = async (url: string) => {
  const response = await axiosInstance.get(`${url}`);
  return response;
};

export const postDataWrapper = async (url: string, body?: any) => {
  const response = await axiosInstance.post(`${url}`, body);
  return response;
};

export const putDataWrapper = async (url: string, body?: any) => {
  const response = await axiosInstance.put(`${url}`, body);
  return response;
};

export const patchDataWrapper = async (url: string, body: any) => {
  const response = await axiosInstance.patch(`${url}`, body);
  return response;
};

export const deleteDataWrapper = async (url: string) => {
  const response = await axiosInstance.delete(`${url}`);
  return response;
};
